/** Admin check utility — calls the backend to verify if the current portal user is an admin. */

import { apiRequest } from "@/shared/lib/apiClient";

export interface AdminInfo {
  id: string;
  email: string;
  name: string;
  role: string;
  provider: string;
  status: string;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface AdminCheckResponse {
  is_admin: boolean;
  admin?: AdminInfo;
}

export async function checkAdminStatus(): Promise<AdminCheckResponse> {
  return apiRequest<AdminCheckResponse>("GET", "/api/metrics/admin-check");
}
